import {Component, Inject, OnInit, AfterViewInit, AfterContentInit, viewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '../../Common/modal-window/modal-window.service';
import { ModalWindowBaseComponent } from '../../Common/modal-window/modal-window-base.component';
import { PasarelaPagoService } from '../../Common/pasarela-pago.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'dialog-aviso-legal',
    templateUrl: './dialog-aviso-legal.component.html',
    styleUrls: ['./dialog-aviso-legal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
    ]
})
export class DialogAvisoLegalComponent extends ModalWindowBaseComponent implements AfterContentInit, OnInit {
    public readonly scroll = viewChild<any
// constructor() { }
>('scroll');

    // constructor() { }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        setTimeout(() => this.scroll().nativeElement.scrollTo(0,0), 400);
    }
}
